import { render, staticRenderFns } from "./AdminExamSettingsExaminersIndex.vue?vue&type=template&id=7affa3eb"
import script from "./AdminExamSettingsExaminersIndex.vue?vue&type=script&lang=js"
export * from "./AdminExamSettingsExaminersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports